<template>
	<div v-if="imiGoShippingMethods.length > 0">
		<div v-if="numberOfProductsSentFromStore > 0 && canShipNow && firstShippingMethod && ! isDownload">
			<div  v-for="(shippingMethodItem, index) in shipFromStoreNowMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					v-if="splittableMethodIds.includes(shippingMethodItem.id)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:isActive="isActive"
					:normalShippingPrice="getNormalShippingPrice(shippingMethodItem.id)"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="firstShippingMethod"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive && ! isCorporateCustomer && (shippingMethodItem.id === 20 && hideBadShippingMethod ? false : true)" class="col-xs-12 divider" :class="{'border-bottom': index != shipFromStoreNowMethods.length - 1}" />
			</div>
		</div>

		<div v-else-if="numberOfProductsSentFromStore > 0 && ! firstShippingMethod && canShipNow && ! isDownload">
			<div v-for="(shippingMethodItem, index) in shipFromStoreLaterMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					v-if="!splittableShippingOptions.includes(shippingMethodItem.id)"
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:cart="cart"
					:isActive="isActive"
					:normalShippingPrice="getNormalShippingPrice(shippingMethodItem.id)"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:isAllProductsSentFromStore="isAllProductsSentFromStore"
					:firstShippingMethod="firstShippingMethod"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive && ! isCorporateCustomer && (shippingMethodItem.id === 20 && hideBadShippingMethod ? false : true)" class="col-xs-12 divider" :class="{'border-bottom': index != shipFromStoreLaterMethods.length - 1}" />
			</div>
		</div>

		<div v-else >
			<div v-for="(shippingMethodItem, index) in imiGoShippingMethods" :key="shippingMethodItem.id">
				<shippingMethodItem
					v-if="shippingMethodItem.id === 20 && hideBadShippingMethod ? false : true"
					@click.native="selectShippingMethod(shippingMethodItem, false, true)"
					:shippingMethod="shippingMethodItem"
					:selectedMethodId="selectedMethodId"
					:selectedZipCode="selectedZipCode"
					:stockAvailability="stockAvailability"
					:isLastRow="index === (imiGoShippingMethods.length - 1)"
					:selectedShippingOption="selectedShippingOption"
					@update:selectedShippingMethodId="v => $emit('update:selectedShippingMethodId', v)"
					@update:selectedShippingOption="v => $emit('update:selectedShippingOption', v)"
					:numberOfProductsSentFromStore="numberOfProductsSentFromStore"
					:cart="cart"
					:isActive="isActive"
					:normalShippingPrice="getNormalShippingPrice(shippingMethodItem.id)"
					:canShipNow="canShipNow"
					:isDownload="isDownload"
					:involvesShipFromStore="involvesShipFromStore"
				/>
				<div v-if="isActive && ! isCorporateCustomer && (shippingMethodItem.id === 20 && hideBadShippingMethod ? false : true)" class="col-xs-12 divider" :class="{'border-bottom': ! (selectedShippingMethodId === shippingMethodItem.id || index === (imiGoShippingMethods.length - 1))}" />
			</div>
		</div>
		<div v-if="displayMoreBtn" class="list-group-item col-xs-12" @click="showMore = true">
			<span class="glyphicon glyphicon-chevron-down" />
			<a class="pl-5">Visa fler</a>
		</div>
	</div>
	<loading-spinner v-else />
</template>

<script>
import alert from 'alert';
import bus from 'eventbus';
import mediaQuery from 'mediaQuery';
import { convertToCdnUrl } from 'utils';
import localSessionStorage from 'localSessionStorage';
import shippingMethodItem from './shipping-method-item';
import { mapGetters, mapState } from 'vuex';
import { selectCheckoutOption } from 'gtm';
import { debounce, isEqual } from 'lodash';

export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		cart: {
			type: Object,
			required: true,
		},
		shippingPriceMap: {
			type: Object,
			required: true,
		},
		testConstraint: {
			type: Function,
		},
		selectedZipCode: {
			type: Number,
		},
		stockAvailability: {
			type: Object,
			required: true,
		},
		isActive: {
			type: Boolean,
		},
		activeStep: {
			type: Number,
		},
		selectedShippingOption: {},
		selectedShippingMethodId: {},
		isCorporateCustomer: {
			type: Boolean,
			required: true,
		},
		numberOfProductsSentFromStore: {
			type: Number,
		},
		firstShippingMethod: {
			type: Boolean,
		},
		isAllProductsSentFromStore: {
			type: Boolean
		},
		canShipNow: {
			type: Boolean
		},
		isDownload: {
			type: Boolean,
			default: false,
		},
		mostExpensiveProductInCart: {},
		imiGoShippingMethods: {},
		involvesShipFromStore: {
			type: Boolean
		},
	},
	components: {
		shippingMethodItem,
	},
	data() {
		return {
			mediaQuery,
			selectedMethodId: null,
			shippingMethods: [],
			showMore: false,
			errorAlertSent: false,
			excludedShippingMethods: {},
			shippingPrice: 0,
			noBorderBottomNotLoggedIn: [1, 4, 5],
			noBorderBottomLoggedIn: [2, 4, 5, 6],
			shipFromStoreNowMethods: [],
			shipFromStoreLaterMethods: []
		};
	},
	beforeDestroy () {
		bus.$off('freeShipppingIsAvailable', this.disableMethod);
	},
	created () {
		this.debouncer = debounce(this.debouncer, 500);
	},
	mounted() {
		bus.$on('freeShipppingIsAvailable', this.disableMethod);
	},
	updated() {
		if (this.isActive) {
			this.imiGoShippingMethods.forEach(shippingMethod => {
				if (shippingMethod.id === this.selectedShippingMethodId) {
					this.shippingPrice = shippingMethod.price;
				}
			});
			// if (this.selectedShippingMethodId && this.selectedMethodId !== this.selectedShippingMethodId) {
			// 	this.selectedMethodId = this.selectedShippingMethodId;
			// 	if (! this.isVisible) {
			// 		this.selectShippingMethod(this.shippingMethods[0], true);
			// 	}
			// 	this.imiGoShippingMethods.forEach(shippingMethod => {
			// 		if (shippingMethod.id === this.selectedShippingMethodId) {
			// 			this.shippingPrice = shippingMethod.price;
			// 		}
			// 	});
			// }
		}
	},
	methods: {
		debouncer: function () {
			this.handleShippingPriceChange(this.availableShippingMethods);
		},
		handleShippingPriceChange (items) {
			const updatedPrice = items.find(element => element.id === this.selectedMethodId);
			/* Checks if price shippingPriceMap differs from current shippingPrice */
			if (updatedPrice && updatedPrice.price !== this.shippingPrice) {
				this.shippingPrice = updatedPrice.price;
			}
		},
		disableMethod (value) {
			if (value && this.selectedShippingMethodId === 20) {
				if (this.shippingMethods.length > 0) {
					const methods = this.getAvailableShippingMethods();
					methods.forEach(method => {
						if (method.id !== 20) {
							this.selectShippingMethod(method, true);
						}
					});
				}
			}
		},
		selectShippingMethod (item, shippingMethodsUpdated = false, isClick = false) {
			if (! item) {
				return;
			}
			// if (! item) {
			// 	this.selectedMethodId = null;
			// 	this.$emit('update:selectedShippingMethodId', null);
			// 	this.shippingPrice = 0;
			// } else
			if (! this.isActive && ! shippingMethodsUpdated) {
				bus.$emit('stepUpdated', 2, null);
			} else if (this.activeStep === 1) {
				this.shippingPrice = 0;
			} else if ((item.id !== this.selectedMethodId) || (this.isActive && this.selectedShippingMethodId === null)) {
				if (isClick) {
					selectCheckoutOption(2, item.name);
				}
				this.selectedMethodId = item.id;
				// this.selectedMethodId = this.isVisible ? this.selectedMethodId : null;
				const shippingPrice = this.selectedMethodId ? item.price : 0;
				localSessionStorage.set('checkout:selectedShippingMethodId', this.selectedMethodId);
				localSessionStorage.set('checkout:selectedShippingServiceCode', item.deliveryCode);
				this.$emit('update:selectedShippingMethodId', this.selectedMethodId);
				this.shippingPrice = shippingPrice;
			}
		},
		defaultShippingMethod () {
			if (this.shippingMethods.length) {
				let savedMethodId = localSessionStorage.get('checkout:selectedShippingMethodId');

				if ((this.selectedShippingMethodId === null && ! savedMethodId) || this.numberOfProductsSentFromStore > 0) {
					// Vi vill inte autovälja något för "nya" besökare
					return;
				}
				if (this.isStoreReservation && this.testConstraint('shippingMethod', 4)) {
					this.$emit('update:selectedShippingMethodId', 4);
					return;
				}
				let value = null;
				if (savedMethodId) {
					savedMethodId = parseInt(savedMethodId);
				}
				let savedMethod = null;
				for (const method of this.shippingMethods) {
					if (method.disabled) {
						continue;
					}
					if (method.value === savedMethodId) {
						savedMethod = method;
					}
					if (value === null || value === 20 /* Fri frakt ska ej prioriteras */) {
						value = method;
					}
					if (method.value === this.selectedShippingMethodId) {
						value = method;
					}
				}

				this.selectShippingMethod(savedMethod ? savedMethod : value, true);
			}
		},
		// getShippingMethods () {
		// 	if (this.selectedZipCode) {
		// 		const data = {
		// 			postalCode: this.selectedZipCode,
		// 			filters: {
		// 				order_value: this.cartSum,
		// 				order_weight: this.orderWeight,
		// 				order_volume: this.orderVolume,
		// 				is_bulky: 'false',
		// 				customer_rank_level: this.user.rankLevel,
		// 				has_digital_products: this.isDownload,
		// 				is_to_large_for_instabox_home: 'false',
		// 				is_to_large_for_instabox_box: 'false',
		// 				is_to_large_for_budbee_home: 'false',
		// 				is_to_large_for_budbee_box: 'false',
		// 				is_corporate_customer: this.isCorporateCustomer,
		// 				delivery_method: this.selectedShippingMethodId === 4 ? 'store' : 'ship',
		// 				shipping_class: this.mostExpensiveProductInCart.shippingClass.id,
		// 			}
		// 		};

		// 		waja.post('imi-go/shipping-methods')
		// 	 		.data(data)
		// 	 		.on('success', res => {
		// 				this.imiGoShippingMethods = res.data;
		// 			}).go();
		// 	}
		// },
		getAvailableShippingMethods () {
			if (! this.sortedShippingSuggestions || this.sortedShippingSuggestions.length == 0) {
				return [];
			} else {
				// unused
				this.loadExcludedShippingMethods;
				const shippingPriceMap = this.shippingPriceMap;
				const methods = [];
				this.sortedShippingSuggestions.forEach(el => {
					const method = Object.assign({}, this.shippingMethods.find(ele => ele.id == el));
					if (! method ||
						method.id === 4 ||
						(method.id === 1 && this.isCorporateCustomer) ||
						(method.id === 2 && ! this.isCorporateCustomer)
					){
						return;
					}

					const packageTooLarge = method.maximumPackageSizeId !== null && this.highestPackageSizeId > method.maximumPackageSizeId;
					const price = shippingPriceMap[method.value + ''];

					if (price === undefined) {
						return;
					}
					method.price = price;
					method.disabled = false;

					if (this.highestPackageSizeId > 2) {
						method.label = method.label.pallet;
						method.description = method.description.pallet;
						method.isPostnordPallet = method.id === 3 && method?.postnordPalletTimeSlots.length > 0;
					} else {
						method.label = method.label.default;
						method.description = method.description.default;
						method.isPostnordPallet = false;
					}

					if (packageTooLarge || ! this.testConstraint('shippingMethod', method.value) || this.excludedShippingMethods[method.value]) {
						if (method.keepWhenDisabled) {
							method.disabled = true;
						} else {
							return;
						}
					}

					if ((method.optionInfo && method.optionInfo.requiresOptions && (! method.options || method.options.length === 0)) || // requires options but none are avaiable
						method.id === 25 && method.options === null) { // Budbee and no options for dates
						return;
					}
					methods.push(method);
				});

				if (this.selectedShippingMethodId && methods.length > 0 && ! methods.find(m => m.id === this.selectedShippingMethodId)) {
					if (! this.errorAlertSent) {
						this.errorAlertSent = true;
						this.$nextTick(() => {
							alert('Valt fraktsätt är inte kompatibelt med nuvarande varukorg');
						});
						setTimeout(() => {
							this.errorAlertSent = false;
						}, 2000);
					}
					this.selectShippingMethod(methods[0], true);
					if (this.isActive) {
						bus.$emit('stepUpdated', 2, null);
					}
				}
				return methods;
			}
		},
		getNormalShippingPrice (id) {
			let Normalprice = {};
			this.mostExpensiveProductInCart.shippingClass.prices.forEach(price => {
				if (price.shippingMethodId == id) {
					Normalprice = price;
				}
			});
			return Normalprice;
		},
	},
	computed: {
		hideBadShippingMethod () {
			const methods = this.getAvailableShippingMethods();
			const method = Object.assign({}, methods.find(m => m.id == 1));
			return method.price < 1 ? true : false;
		},
		availableShippingMethods() {
			return this.showMore ? this.getAvailableShippingMethods() : this.getAvailableShippingMethods().slice(0, 7);
		},
		highestPackageSizeId () {
			let highestPackageSizeId = -1;
			for (const row of this.cart.rows) {
				const pid = row.product.packageSizeId | 0;
				if (pid > highestPackageSizeId) {
					highestPackageSizeId = pid;
				}
			}
			return highestPackageSizeId;
		},
		isVisible () {
			return this.availableShippingMethods.some(method => method.id === this.selectedMethodId);
		},
		displayMoreBtn () {
			if (this.showMore || ! this.isActive) {
				return false;
			}

			if (this.getAvailableShippingMethods().length > 7) {
				return true;
			}
			return false;
		},
		sortedShippingSuggestions () {
			const unsorted = [1,2,3,4,5,6,7,8,9,10]; // default unsorted
			const sorted = this.user.shippingSuggestions.slice();

			if (this.shippingMethods.length > 0) {
				const shippingMethods = [];
				sorted.forEach(suggestion => {
					shippingMethods.push(Object.assign({}, this.shippingMethods.find(el => el.id === suggestion)));
				});

				shippingMethods.sort((a,b) => {
					if (! Number.isInteger(this.shippingPriceMap[a.id + ''])) {
						return 1;
					} else if(! Number.isInteger(this.shippingPriceMap[b.id + ''])) {
						return -1;
					}

					if (this.shippingPriceMap[a.id + ''] - this.shippingPriceMap[b.id + ''] === 0) {
						let aEta = new Date();
						let bEta = new Date();

						aEta.setDate(aEta.getDate() + a.estimatedDelivery.days[0][1]);
						bEta.setDate(bEta.getDate() + b.estimatedDelivery.days[0][1]);

						if (a.options) {
							if (a.options[0] && a.options[0].etaDate) {
								aEta = new Date(a.options[0].etaDate);
							} else if( a.options.etaDate) {
								aEta = new Date(a.options.etaDate);
							}
						}
						if (b.options) {
							if (b.options[0] && b.options[0].etaDate) {
								bEta = new Date(b.options[0].etaDate);
							} else if (b.options.etaDate) {
								bEta = new Date(b.options.etaDate);
							}
						}

						aEta.setHours(0,0,0,0);
						bEta.setHours(0,0,0,0);

						if (aEta < bEta) {
							return -1;
						} else if (aEta > bEta) {
							return 1;
						} else {
							return 0;
						}
					} else {
						return this.shippingPriceMap[a.id + ''] - this.shippingPriceMap[b.id + ''];
					}
				});

				let defaultResult = shippingMethods.map(el => {return el.id; });

				if (! isEqual(sorted.slice(0,10), unsorted)) { // if suggestions are not sorted in default sorting then we can assume that they are sorted in a specific way. Therefore return without changing.
					const sortedCopy = defaultResult.slice(0, 10);
					const mvpOptions = [28, ...sortedCopy, ...defaultResult].slice(0, 3); // Add specific id to always come first, and take the first four
					return [...new Set([...mvpOptions, 27, 1, 26, 29, 25, 3, 2, 5])]; // Make a set with all other ids in order
				}
				return defaultResult;
			}
			return [];
		},
		loadExcludedShippingMethods() {
			this.excludedShippingMethods = {};
			for (const row of this.cart.rows) {
				if (row.product.meta.excluded_shipping_methods) {
					for(let methodId of row.product.meta.excluded_shipping_methods) {
						this.excludedShippingMethods[methodId] = 1;
					}
				}
			}
		},
		orderVolume () {
			let volume = 0;
			for (const row of this.cart.rows) {
				volume += Math.ceil(row.product.packageVolume / 1000000);
			}
			return volume;
		},
		orderWeight () {
			let weight = 0;
			for (const row of this.cart.rows) {
				weight += row.product.packageWeight;
			}
			return weight;
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			cartSum: 'cart/sum',
		}),
		...mapState({
			splittableShippingOptions: state => state.shippingMethodRelatedInfo.splittableShippingOptions,
			fromStoreShipmentOptions: state => state.shippingMethodRelatedInfo.fromStoreShipmentOptions,
		}),
	},
	watch: {
		cartSum () {
			// this.getShippingMethods();
		},
		shippingMethods () {
			this.defaultShippingMethod();
		},
		isCorporateCustomer () {
			// this.getShippingMethods();
		},
		selectedZipCode (to) {
			// this.getShippingMethods();
		},
		imiGoShippingMethods () {
			if (this.numberOfProductsSentFromStore > 0) {
				this.shipFromStoreNowMethods = this.imiGoShippingMethods.filter(method => (this.fromStoreShipmentOptions.includes(method.id)));
				this.shipFromStoreLaterMethods = this.imiGoShippingMethods.filter(method => (!this.fromStoreShipmentOptions.includes(method.id)));
			}
		},
		isActive (to) {
			if (to) {
				let methodId = 0;
				if (! this.selectedShippingMethodId) {
					this.selectShippingMethod(this.getAvailableShippingMethods()[0], true);
					if (this.isAllProductsSentFromStore) {
						methodId = null;
					}
					this.selectShippingMethod(this.getAvailableShippingMethods()[methodId], true);
				}
				console.log(this.imiGoShippingMethods);
				const method = Object.assign({}, this.shippingMethods.find(m => m.id == this.selectedMethodId));
				const price = this.shippingPriceMap[method.value + ''];

				if (price) {
					bus.$emit('shipping-updated', price);
					this.shippingPrice = price;
				}
			}
		},
		selectedMethodId (to, frm) {
			const method = Object.assign({}, this.shippingMethods.find(m => m.id == to));
			const price = this.shippingPriceMap[method.value + ''];
			this.$emit('update:stepSelection', method.name);
			this.shippingPrice = price;
		},
		shippingPrice (to, frm) {
			if (to !== frm) {
				bus.$emit('shipping-updated', to);
			}
		},
		activeStep (to) {
			if (to === 1) {
				this.selectShippingMethod(null, false);
			}
		},
		shippingPriceMap (to, frm) {
			if (to !== frm && this.selectedMethodId) {
				this.debouncer.call();
			}
		}
	},
};
</script>

